<template>
	<div class="chat-header">
		<div class="chat-header-icon">
			<CommentsIcon class="dm-icon" v-if="isDM" type="regular" />
			<div class="thread-icon" v-else-if="isThread">
				<ReelIcon type="solid" />
			</div>
			<GroupIcon class="group-icon" v-else :chatId="chatId" />
		</div>

		<div class="chat-header-title">
			{{ displayTitle }}
		</div>

		<!-- Slot for specific implementation details -->
		<slot></slot>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { CommentsIcon, ReelIcon } from '@/icons'
import { useI18n } from 'vue-i18n'
import GroupIcon from '@/components/common/GroupIcon'

const { t } = useI18n()

const props = defineProps({
	isDM: Boolean,
	isThread: Boolean,
	title: String,
	chatId: Number,
})

//computed properties
const displayTitle = computed(() => {
	return props.isDM ? t('chat_stream_header_title_dm') : props.title
})
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.chat-header {
	padding: 1rem;
	.chat-header-title {
		font-family: Avenir-Heavy;
		font-size: 28px;
		color: var(--neutral-800);
	}

	.chat-header-icon {
		margin-bottom: 12px;
		.group-icon {
			font-size: 50px;
			background-color: var(--neutral-100);
			:deep(.group-icon-emoji) {
				margin-top: 4px;
			}
		}
		.dm-icon {
			font-size: 30px;
			color: var(--teal-300);
		}
		.thread-icon {
			width: 50px;
			height: 50px;
			border-radius: 8px;
			background: var(--neutral-100);
			display: flex;
			align-items: center;
			justify-content: center;
			.pronto-icon {
				font-size: 30px;
				transform: rotate(30deg);
				color: var(--neutral-400);
			}
		}
	}
}

@include overrideScheme('dark') {
	.chat-header {
		.chat-header-icon {
			.thread-icon {
				background: var(--neutral-200);
			}
		}
	}
}
</style>
